import { render, staticRenderFns } from "./datamodal.vue?vue&type=template&id=469bd6d6&"
import script from "./datamodal.vue?vue&type=script&lang=js&"
export * from "./datamodal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports